import {inject, Pipe, PipeTransform} from '@angular/core';
import {TranslocoService} from '@jsverse/transloco';

@Pipe({
  name: 'appDate',
})
export class AppDatePipe implements PipeTransform {
  private readonly translocoService = inject(TranslocoService);

  transform(value: string | null | undefined): string {
    if (!value) return '';

    const [year, month, day] = value.split('T')[0].split('-').map(Number);
    const date = new Date(Date.UTC(year, month - 1, day));
    if (isNaN(date.getTime())) return '';

    return new Intl.DateTimeFormat(this.translocoService.getActiveLang(), {
      timeZone: 'UTC',
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    }).format(date);
  }
}
